import { useQuery } from '@tanstack/react-query';
import { runQuery } from '@shadcn/hooks/use-run-query';
import { listTablesSql } from '@shadcn/lib/pg-meta';
import { projectStore } from '~/lib/stores/project';

const listTables = ({ schemas }: { schemas?: string[] }) => {
  const sql = listTablesSql(schemas);
  return runQuery({
    query: sql,
  });
};

export const useListTables = (schemas?: string[]) => {
  const projectId = projectStore.projectId.get();
  return useQuery({
    queryKey: ['tables', projectId, schemas],
    queryFn: () => listTables({ schemas }),
    enabled: !!projectId,
  });
};
